import React from "react";
import { Send, Smile } from "lucide-react";
import { PICKER_EMOJIS } from "./chatUtils";

export const ChatComposer = ({
  joined, username, setUsername, onJoin,
  text, setText, onSend, sending,
  showPicker, setShowPicker, onInsertEmoji, inputRef,
}) => (
  <div className="border-t border-white/[0.08] p-4">
    {!joined ? (
      <form onSubmit={onJoin} className="flex gap-3" data-testid="chat-join-form">
        <input
          data-testid="chat-username-input"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Ton pseudo (max 20)…"
          maxLength={20}
          className="flex-1 min-w-0 bg-black/40 border border-white/[0.1] px-4 py-3 text-sm text-white placeholder:text-[#8A8A8A] focus:outline-none focus:border-gold/50 transition-colors"
        />
        <button
          data-testid="chat-join-btn"
          className="shrink-0 bg-gold text-black font-medium px-5 sm:px-6 py-3 text-sm hover:bg-gold-light transition-colors"
        >
          Rejoindre
        </button>
      </form>
    ) : (
      <form onSubmit={onSend} className="flex gap-2 relative" data-testid="chat-send-form">
        {showPicker && (
          <div
            data-testid="emoji-picker"
            className="absolute z-30 bottom-14 left-0 grid grid-cols-8 gap-1 bg-[#141414] border border-white/[0.12] rounded-lg p-2 shadow-2xl w-[280px]"
          >
            {PICKER_EMOJIS.map((emoji) => (
              <button
                key={emoji}
                type="button"
                data-testid={`emoji-pick-${emoji}`}
                onClick={() => onInsertEmoji(emoji)}
                className="text-lg hover:bg-white/10 rounded p-1 transition-colors"
              >
                {emoji}
              </button>
            ))}
          </div>
        )}
        <button
          type="button"
          data-testid="emoji-toggle-btn"
          onClick={() => setShowPicker((v) => !v)}
          className="shrink-0 border border-white/[0.1] px-3 text-[#A3A3A3] hover:text-gold hover:border-gold/50 transition-colors"
        >
          <Smile className="w-4 h-4" />
        </button>
        <input
          ref={inputRef}
          data-testid="chat-message-input"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Ton message…"
          maxLength={500}
          className="flex-1 min-w-0 bg-black/40 border border-white/[0.1] px-4 py-3 text-sm text-white placeholder:text-[#8A8A8A] focus:outline-none focus:border-gold/50 transition-colors"
        />
        <button
          data-testid="chat-send-btn"
          disabled={sending}
          className="shrink-0 bg-gold text-black px-5 py-3 hover:bg-gold-light transition-colors disabled:opacity-50 flex items-center gap-2"
        >
          <Send className="w-4 h-4" />
        </button>
      </form>
    )}
  </div>
);
